module.exports = __webpack_public_path__ + "img/sicilia.477bc8ba.jpg";